var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Pager from '../shared/Pager.vue';
import Loader from '../shared/Loader.vue';
import Cta from '../shared/Cta.vue';
import SocialLink from '../shared/SocialLink.vue';
import Choices from 'choices.js';
const service = namespace('Service');
let EngagementsList = class EngagementsList extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.filteredData = [];
        this.args = {};
        this.itemPerPage = 10;
        this.pageTotal = 0;
        this.currentPage = 1;
        this.filter1Options = [];
        this.filter2Options = [];
        this.filter3Options = [];
        this.select1 = null;
        this.select2 = null;
        this.select3 = null;
        this.filter1 = 'newest';
        this.filter2 = '';
        this.filter3 = '';
        this.selectProps = {
            searchEnabled: true,
            shouldSort: false,
            removeItemButton: true,
            itemSelectText: ''
        };
    }
    created() {
        this.args = {
            siteId: window.cibbic.siteId,
        };
        this.getPublicEngagements(this.args);
    }
    mounted() {
        this.select2 = new Choices('#filter2', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'filter2Label' }));
        this.select3 = new Choices('#filter3', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'filter3Label' }));
        this.selectProps.searchEnabled = false;
        this.selectProps.removeItemButton = false;
        this.select1 = new Choices('#filter1', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'filter1Label' }));
        this.select1.setChoices([{ value: 'newest', label: this.labels.newest, selected: true }, { value: 'older', label: this.labels.older }]);
    }
    onPageChange(page) {
        this.currentPage = page;
        this.filterData();
    }
    stripHtml(value) {
        const div = document.createElement('div');
        div.innerHTML = value;
        return div.textContent || div.innerText || '';
    }
    filterData() {
        this.filteredData = this.engagementsData.entries.slice((this.currentPage - 1) * this.itemPerPage, this.itemPerPage * this.currentPage);
    }
    onFilter1Changed(evt) {
        if (this.filter2 || this.filter3) {
            this.filter1 = evt.detail.value;
            return;
        }
        let value = evt.detail.value;
        this.reorder(value);
    }
    reorder(order, force = false) {
        if (order != this.filter1 || force) {
            this.engagementsData.entries.reverse();
            this.filterData();
            this.filter1 = order;
        }
    }
    onFilter2Changed(evt) {
        var _a, _b;
        if (evt.detail.value !== this.filter2) {
            this.filter2 = evt.detail.value;
            this.filteredData = this.engagementsData.entries.filter((i) => { return i.id === evt.detail.value; });
            this.pageTotal = Math.ceil(this.filteredData.length / this.itemPerPage);
            this.currentPage = 1;
            (_a = this.select3) === null || _a === void 0 ? void 0 : _a.disable();
        }
        else {
            this.filter2 = '';
            this.pageTotal = Math.ceil(this.engagementsData.count / this.itemPerPage);
            this.currentPage = 1;
            this.filterData();
            if (this.filter1) {
                this.reorder(this.filter1, true);
            }
            (_b = this.select3) === null || _b === void 0 ? void 0 : _b.enable();
        }
    }
    onFilter3Changed(evt) {
        var _a, _b;
        if (evt.detail.value !== this.filter3) {
            this.filter3 = evt.detail.value;
            this.filteredData = this.engagementsData.entries.filter((i) => { return i.subtitle === evt.detail.value; });
            this.pageTotal = Math.ceil(this.filteredData.length / this.itemPerPage);
            this.currentPage = 1;
            (_a = this.select2) === null || _a === void 0 ? void 0 : _a.disable();
        }
        else {
            this.filter3 = '';
            this.pageTotal = Math.ceil(this.engagementsData.count / this.itemPerPage);
            this.currentPage = 1;
            this.filterData();
            (_b = this.select2) === null || _b === void 0 ? void 0 : _b.enable();
            if (this.filter1) {
                this.reorder(this.filter1, true);
            }
        }
    }
    onDataChanged() {
        var _a, _b;
        this.loading = false;
        this.filterData();
        this.pageTotal = Math.ceil(this.engagementsData.count / this.itemPerPage);
        let names = [];
        let orgs = [];
        this.engagementsData.entries.forEach((i) => {
            names.push({ value: i.id, label: i.title });
            let exist = orgs.find((o) => { return o.subtitle === i.subtitle; });
            if (!exist) {
                orgs.push({ value: i.subtitle, label: i.subtitle });
            }
        });
        (_a = this.select2) === null || _a === void 0 ? void 0 : _a.setChoices(names, 'value', 'label', true);
        (_b = this.select3) === null || _b === void 0 ? void 0 : _b.setChoices(orgs, 'value', 'label', true);
    }
};
__decorate([
    Prop({ type: Object })
], EngagementsList.prototype, "labels", void 0);
__decorate([
    service.State
], EngagementsList.prototype, "engagementsData", void 0);
__decorate([
    service.Action
], EngagementsList.prototype, "getPublicEngagements", void 0);
__decorate([
    Watch('engagementsData')
], EngagementsList.prototype, "onDataChanged", null);
EngagementsList = __decorate([
    Component({
        components: {
            Pager,
            Loader,
            Cta,
            SocialLink,
        }
    })
], EngagementsList);
export default EngagementsList;
